import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';

const PaginationOverrides = () => (
  <style>{`
  .MuiTablePagination-root .MuiTablePagination-actions .MuiIconButton-root,
  .MuiTablePagination-root .MuiTablePagination-actions .MuiIconButton-sizeSmall {
    padding: 4px !important;
    margin: 0 1px !important;
  }
  .MuiTablePagination-root .MuiSvgIcon-root {
    width: 24px;
    height: 24px;
  }
  .MuiTablePagination-root .MuiSelect-root,
  .MuiTablePagination-root .MuiInputBase-root,
  .MuiTablePagination-root .MuiSelect-icon {
    color: grey !important;
  }
  .MuiTablePagination-root p.MuiTypography-root {
    color: grey !important;
  }
  
  /* Oculta a informação de paginação (0-0 of 0) */
  .MuiTablePagination-displayedRows {
    display: none !important;
  }
  
  .MuiTablePagination-selectRoot {
    margin-right: 2px !important;  /* Reduzir margem à direita */
  }
  
  /* Reduz o espaçamento nas ações (setas) */
  .MuiTablePagination-actions {
    margin-left: 0 !important;     /* Remove margem à esquerda */
  }
  
  /* Comprime o toolbar para reduzir espaços */
  .MuiTablePagination-toolbar {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  `}</style>
);

// Estilos para TextField com labels longos
const TextFieldOverrides = () => (
  <style>{`
  /* Estilos globais para TextField com labels longos */
  .MuiTextField-root .MuiInputLabel-root {
    line-height: 1.2 !important;
    white-space: normal !important;
    max-width: 100% !important;
    word-break: break-word !important;
    overflow: visible !important;
  }
  
  .MuiTextField-root .MuiInputLabel-outlined {
    transform: translate(14px, -6px) scale(0.75) !important;
    transform-origin: top left !important;
  }
  
  .MuiTextField-root .MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75) !important;
    white-space: normal !important;
    word-break: break-word !important;
  }
  
  /* Garante que o contorno do campo acompanhe a label */
  .MuiTextField-root .MuiOutlinedInput-notchedOutline {
    text-align: left !important;
  }
  
  .MuiTextField-root .MuiOutlinedInput-notchedOutline > legend {
    max-width: 100% !important;
    white-space: normal !important;
  }


  
  /* Ajustes para o tamanho dos campos e espaçamento para telas menores */
  @media (max-width: 1280px) {
    .MuiTextField-root .MuiOutlinedInput-input {
      padding: 12px 14px !important;
    }
    
    .MuiFormControl-root {
      margin-top: 10px !important;
      margin-bottom: 6px !important;
    }
  }
  `}</style>
);

// Estilos para ExpansionPanel e títulos
const ExpansionPanelOverrides = () => (
  <style>{`
  /* Ajustes para ExpansionPanelTituloTamanho */
  .ExpansionPanelTitulo-root {
    width: 100% !important;
    overflow: hidden !important;
    display: flex !important;
    align-items: center !important;
  }
  
  .ExpansionPanelTitulo-heading {
    font-size: 20px !important;
    font-weight: bold !important;
    word-break: break-word !important;
    white-space: normal !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    max-width: calc(100% - 70px) !important;
  }
  
  .ExpansionPanelTitulo-chipContainer {
    flex-shrink: 0 !important;
    margin-left: 8px !important;
  }
  
  /* Ajustes para ExpansionPanel/Accordion */
  .MuiAccordion-root, .MuiExpansionPanel-root {
    margin: 8px 0 !important;
  }
  
  .MuiAccordionSummary-root, .MuiExpansionPanelSummary-root {
    min-height: 48px !important;
    padding: 0 16px !important;
  }
  
  .MuiAccordionSummary-content, .MuiExpansionPanelSummary-content {
    margin: 8px 0 !important;
  }
  
  .MuiAccordionSummary-content.Mui-expanded, .MuiExpansionPanelSummary-content.Mui-expanded {
    margin: 8px 0 !important;
  }
  
  .MuiAccordionDetails-root, .MuiExpansionPanelDetails-root {
    padding: 8px 16px 16px !important;
  }
  `}</style>
);

// Estilos para responsividade geral
const ResponsiveOverrides = () => (
  <style>{`
  /* Ajustes gerais para telas menores */
  @media (max-width: 1280px) {
    /* Reduz o espaçamento entre elementos do grid */
    .MuiGrid-container > .MuiGrid-item {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
    
    /* Reduz o tamanho dos botões */
    .MuiButton-root {
      font-size: 0.85rem !important;
      padding: 6px 12px !important;
    }
    
    /* Reduz o padding das células de tabela */
    .MuiTableCell-root {
      padding: 8px 12px !important;
    }
    
    .MuiTableCell-head, .MuiTableCell-body {
      font-size: 0.85rem !important;
    }
    
    /* Reduz o padding de cards */
    .MuiCardContent-root {
      padding: 12px !important;
    }
    
    .MuiCardContent-root:last-child {
      padding-bottom: 12px !important;
    }
    
    /* Reduz o padding de diálogos */
    .MuiDialogTitle-root {
      padding: 12px 16px !important;
    }
    
    .MuiDialogContent-root {
      padding: 8px 16px !important;
    }
    
    .MuiDialogActions-root {
      padding: 8px 16px !important;
    }
  }
  
  /* Ajustes para tipografia em telas menores */
  @media (max-width: 1280px) {
    .MuiTypography-h1 { font-size: 2rem !important; }
    .MuiTypography-h2 { font-size: 1.75rem !important; }
    .MuiTypography-h3 { font-size: 1.5rem !important; }
    .MuiTypography-h4 { font-size: 1.25rem !important; }
    .MuiTypography-h5 { font-size: 1rem !important; }
    .MuiTypography-h6 { font-size: 0.9rem !important; }
    .MuiTypography-body1, .MuiTypography-body2 { font-size: 0.875rem !important; }
  }
  `}</style>
);

const ExpansionPanelTituloTamanhoCSS = () => (
  <style>{`
  .custom-expansion-panel-titulo {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    overflow: hidden !important;
  }
  
  .custom-expansion-panel-titulo .MuiTypography-root {
    font-size: 20px !important;
    font-weight: bold !important;
    word-break: break-word !important;
    white-space: normal !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    max-width: calc(100% - 70px) !important;
  }
  
  .custom-expansion-panel-titulo .chip-container {
    flex-shrink: 0 !important;
    margin-left: 8px !important;
  }
  `}</style>
);

const HideAllTopoElements = () => (
  <style>{`
  /* Oculta qualquer elemento que tenha uma classe contendo "topo" */
  [class*="topo"] {
    display: none !important;
    height: 0 !important;
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  `}</style>
);

// Estilos para tabelas com quebra de linha
const TableWrapOverrides = () => (
  <style>{`
  /* Estilos para TextFields em tabelas para quebra automática de linha */
  .text-field-line-break .MuiInputBase-input {
    white-space: pre-wrap !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    line-height: 1.4em !important;
    min-height: 1.4em !important;
    max-height: 5.6em !important;
    overflow: auto !important;
  }
  
  .text-field-line-break .MuiOutlinedInput-root {
    height: auto !important;
    min-height: 56px !important;
  }
  
  .text-field-line-break .MuiOutlinedInput-input {
    overflow: auto !important;
    text-overflow: initial !important;
    white-space: pre-wrap !important;
  }
  
  /* Estilos para células de tabela com quebra de linha */
  .table-wrap-cell {
    white-space: normal !important;
    word-wrap: break-word !important;
    min-width: 120px !important;
    max-width: 300px !important;
  }
  
  /* Células com mais texto (ex: macroEtapasOuObras) */
  .table-wrap-cell-large {
    white-space: normal !important;
    word-wrap: break-word !important;
    min-width: 250px !important;
    max-width: 400px !important;
  }
  
  /* Para os TextFields multiline */
  .text-field-line-break .MuiInputBase-multiline {
    padding: 0 !important;
  }
  
  /* Ajuste para cabeçalhos das tabelas */
  .MuiTableCell-head.table-wrap-cell,
  .MuiTableCell-head.table-wrap-cell-large {
    font-weight: bold !important;
    vertical-align: top !important;
    line-height: 1.3 !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  
  /* Ajuste para quando o texto da célula é muito grande */
  .table-cell-content {
    max-height: 120px !important; 
    overflow-y: auto !important;
    padding: 5px 0 !important;
  }
  
  /* Especificamente para o campo MacroEtapasOuObras */
  .macro-etapas-wrapper {
    max-height: 200px !important; /* Altura máxima maior */
    overflow-y: auto !important; /* Adiciona rolagem vertical quando necessário */
    overflow-x: hidden !important; /* Impede rolagem horizontal */
    padding: 4px !important;
    white-space: pre-wrap !important;
    word-wrap: break-word !important;
    line-height: 1.5 !important; /* Espaçamento entre linhas para facilitar leitura */
    text-align: left !important;
    font-size: 14px !important;
  }
  
  /* Para o TextField quando em modo edição */
  .macro-etapas-field .MuiInputBase-multiline {
    min-height: 100px !important;
    max-height: 250px !important;
    overflow-y: auto !important;
  }
  
  .macro-etapas-field .MuiInputBase-input {
    line-height: 1.5 !important;
    white-space: pre-wrap !important;
    word-break: break-word !important;
  }
  `}</style>
);

const ValueCellOverrides = () => (
  <style>{`
    /* Target all divs with valueCell class */
    div[class*="valueCell"] {
      text-align: right !important;
    }
    
    /* Target cells with valueCell class */
    .MuiTableCell-root div[class*="valueCell"] {
      text-align: right !important;
    }
  `}</style>
);

(() =>
  createStyles({
    '@global': {
      '.MuiTablePagination-root .MuiTablePagination-actions button.MuiIconButton-root, .MuiTablePagination-root .MuiTablePagination-actions button.MuiIconButton-sizeSmall': {
        padding: '4px !important',
        margin: '0 1px !important'
      },
      '.MuiTablePagination-root .MuiSvgIcon-root': { width: '24px', height: '24px' },
      '.MuiTablePagination-root .MuiTablePagination-actions .MuiIconButton-root, .MuiTablePagination-root .MuiTablePagination-actions .MuiIconButton-sizeSmall': {
        padding: '4px !important',
        margin: '0 1px !important'
      },
    }
  })
)();

export default function GlobalOverrides(): JSX.Element {
  return (
    <>
      <PaginationOverrides />
      <TextFieldOverrides />
      <ExpansionPanelOverrides />
      <ResponsiveOverrides />
      <ExpansionPanelTituloTamanhoCSS />
      <HideAllTopoElements />
      <TableWrapOverrides />
      <ValueCellOverrides />
    </>
  );
}